import { IonAvatar } from '@ionic/react';
import { DEFAULT_AVATAR_URL } from '../../../../appConfig';
import { withAvatarCacheBuster } from '../../../../lib/avatarUrl';

interface ProfileAvatarImageProps {
  picture?: string | null;
  updatedAt?: string | null;
  alt: string;
  className: string;
}

/** Shared profile avatar so every profile surface uses the same no-picture placeholder. */
export const ProfileAvatarImage = ({
  picture,
  updatedAt,
  alt,
  className,
}: ProfileAvatarImageProps) => (
  <IonAvatar className={className}>
    <img
      src={withAvatarCacheBuster(picture, updatedAt) || DEFAULT_AVATAR_URL}
      alt={alt}
      className="h-full w-full rounded-full object-cover"
    />
  </IonAvatar>
);
